import { createContext } from "react";

export const IPSContext = createContext({});
